module.exports = __webpack_public_path__ + "img/新闻中心.b6ca7722.png";